<template>
    <div>
        <el-dialog
            title="提示"
            :visible.sync="ddzytlXqDialogVisible"
            width="60%"
            @close="closeDialogVisible">
            <el-table
                :data="ddzytlXqData"
                style="width: 100%">
                <!-- <el-table-column
                    label="序号"
                    width="60" type="index" :index="indexMethod">
                </el-table-column> -->
                <el-table-column
                    prop="thrxm"
                    label="谈话人姓名"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="thrbmmc"
                    label="谈话人部门">
                </el-table-column>
                <el-table-column
                    prop="bthrxm"
                    label="被谈话人姓名">
                </el-table-column>
                <el-table-column
                    prop="bthrbmmc"
                    label="被谈话人部门">
                </el-table-column>
                <el-table-column
                    prop="thsj"
                    label="谈话时间">
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="ddzytlXqHandleSizeChange"
                @current-change="ddzytlXqHandleCurrentChange"
                :current-page="ddzytlXqCurrentNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="ddzytlXqPageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="ddzytlXqPageTotal">
            </el-pagination>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ddzytlXqDialogVisible = false">取 消</el-button>
                <!-- <el-button type="primary" @click="ddzytlXqDialogVisible = false">确 定</el-button> -->
            </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        ddzytlXqDialogVisible: false,
        ddzytlXqData:[],
        ddzytlXqCurrentNo: 1,
        ddzytlXqPageSize: 10,
        ddzytlXqPageTotal: 0,
        ddzytlXqForm: {}
      }
    },
    methods: {
      init(val) {
          this.ddzytlXqDialogVisible = true
          this.ddzytlXqForm = val
          this.getDdzytlXqByYtjls(val);
      },
      ddzytlXqHandleSizeChange(val) {
        this.ddzytlXqPageSize = val;
        this.getDdzytlXqByYtjls(this.ddzytlXqForm);
      },
      ddzytlXqHandleCurrentChange(val) {
        this.ddzytlXqCurrentNo = val;
        this.getDdzytlXqByYtjls(this.ddzytlXqForm);
      },
      getDdzytlXqByYtjls(val) {
        this.$request({
            url: '/bjba/ddkhgl/getDdzytlXqByYtjls',
            method: 'get',
            params: {
                page: this.ddzytlXqCurrentNo,
                pagesize: this.ddzytlXqPageSize,
                username: val.username,
                month: val.month
            }
        }).then(res => {
            console.log("获取到的大队约谈率--约谈记录数详情数据为：",res)
            this.ddzytlXqDialogVisible = true
            this.ddzytlXqData = res.data.data.content
            this.ddzytlXqPageTotal = res.data.data.totalElements
        }).catch(err => {
            console.log(err)
        })
      },
      closeDialogVisible() {
        this.ddzytlXqCurrentNo = 1
      }
    }
  }
  </script>
  
  <style>
  .echart01 {
      font-size: 10px;
      font-weight: 700;
      width: 300px;
  }
  </style>
  